module.exports = __webpack_public_path__ + "img/moonlight.f1b27836.jpg";